export default "__VITE_ASSET__DDXsS3u7__"